var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card h-100 col-xl-2 col-lg-4 col-md-6 col-sm-12 px-0"},[_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"px-0 text-center"},[_c('img',{attrs:{"src":_vm.connectorLogoSrc}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }